// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","App__Header":"App_App__Header__9cLT6","App__Footer":"App_App__Footer__2QJPi"};